const getFieldsByDocumentType = (type: string, isStrict: boolean = false) => {
  const isMainDocument = type === 'main'

  if (isMainDocument && !isStrict) {
    return ['title', 'longTitle', 'description', 'code', 'effectiveAt']
  }

  return [
    'title',
    'longTitle',
    'description',
    'code',
    'effectiveAt',
    'targetGroup',
    'legalEntities',
    'departments',
    'countries',
    'locations',
    'keywords',
    'certificationScope',
    'collections',
    'contact',
  ]
}

export default getFieldsByDocumentType
